import { useState } from "react";
import { Map, MapPin, Footprints } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";
import { markOnboardingDone } from "../lib/api";

const STEPS = [
  {
    Icon: Map,
    title: "Explore",
    text: "Zoome, déplace-toi, clique sur les punaises pour découvrir les spots près de toi.",
  },
  {
    Icon: MapPin,
    title: "Crée ton spot",
    text: "Clique sur la carte pour signaler un lieu. Ajoute un titre, une catégorie, une photo.",
  },
  {
    Icon: Footprints,
    title: "Laisse ta trace",
    text: "Tu connais un lieu ? Laisse une trace pour indiquer aux autres qu'il est actif.",
  },
];

export default function OnboardingModal({ onClose }) {
  const [step, setStep] = useState(0);
  const { Icon, title, text } = STEPS[step];
  const isLast = step === STEPS.length - 1;

  const handleFinish = async () => {
    try { await markOnboardingDone(); } catch (_) {}
    onClose();
  };

  return (
    <Dialog open={true}>
      <DialogContent
        className="max-w-sm bg-[#1d191a] text-white border-white/10"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <div className="flex justify-end text-xs text-white/40 -mt-1 mb-1">
          {step + 1}/{STEPS.length}
        </div>

        <div className="flex flex-col items-center gap-4 py-2">
          <div className="rounded-full bg-amber-500/15 p-4">
            <Icon className="w-8 h-8 text-amber-400" />
          </div>
          <h2 className="text-xl font-semibold">{title}</h2>
          <p className="text-sm text-white/70 text-center leading-relaxed">{text}</p>
        </div>

        <div className="flex justify-end mt-6">
          {isLast ? (
            <Button
              className="bg-amber-500 hover:bg-amber-600 text-black font-medium"
              onClick={handleFinish}
            >
              C'est parti !
            </Button>
          ) : (
            <Button
              className="bg-amber-500 hover:bg-amber-600 text-black font-medium"
              onClick={() => setStep((s) => s + 1)}
            >
              Suivant
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
